import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

export const EmbeddingStatus = {
	SYNCED: 'SYNCED',
	SYNCING: 'SYNCING',
	OUT_OF_SYNC: 'OUT_OF_SYNC',
	UN_SYNCABLE: 'UN_SYNCABLE'
} as const

export type EmbeddingStatusType = (typeof EmbeddingStatus)[keyof typeof EmbeddingStatus]

export const EMBEDDING_STATUS_PRIORITY: Record<EmbeddingStatusType, number> = {
	[EmbeddingStatus.UN_SYNCABLE]: 3,
	[EmbeddingStatus.OUT_OF_SYNC]: 2,
	[EmbeddingStatus.SYNCING]: 1,
	[EmbeddingStatus.SYNCED]: 0
}

export const EMBEDDING_STATUS_LABELS: Record<EmbeddingStatusType, string> = {
	[EmbeddingStatus.UN_SYNCABLE]: 'Un syncable',
	[EmbeddingStatus.OUT_OF_SYNC]: 'Out of sync',
	[EmbeddingStatus.SYNCING]: 'Syncing',
	[EmbeddingStatus.SYNCED]: 'Synced'
}

export const EMBEDDING_STATUS_ICONS: Record<EmbeddingStatusType, IconName> = {
	[EmbeddingStatus.UN_SYNCABLE]: 'fieldError',
	[EmbeddingStatus.OUT_OF_SYNC]: 'fieldError',
	[EmbeddingStatus.SYNCING]: 'refresh',
	[EmbeddingStatus.SYNCED]: 'checkCircle'
}
